export default __webpack_public_path__ + "static/media/edit.902b2f62.svg";